<template>
  <div
    class="question-ruler"
    :class="{ 'target-ruler': data.que_filed == 'camp_target_weight' }"
  >
    <div v-if="data.que_filed == 'camp_target_weight'">
      <div class="cur-weight">当前体重：{{ curWeight }}{{ data.unit }}</div>
      <div class="target-weight">
        <div class="number"
          >{{ data.value }}
          <div class="unit">{{ data.unit }}</div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="text"
      @click="bindClick"
      :style="{ color: 'rgba(0,0,0,0.9)' }"
    >
      <div class="number"
        >{{ data.value }}
        <div class="unit">{{ data.unit }}</div>
      </div>
    </div>
    <AppRuler
      ref="appRuler"
      style="margin-bottom: 48px"
      @change="bindConfirm"
      :NowNum="NowNum"
      :oneGridValue="data.step_num"
      :maxNum="data.max_num"
      :minNum="data.min_num"
      theme="rgba(0,0,0,0.9)"
    />
  </div>
</template>
<script>
import AppRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    AppRuler
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    question: {
      type: Array,
      default: () => []
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showRuler: false,
      NowNum: 0
    }
  },
  computed: {
    id() {
      return this.data.id
    },
    curWeight() {
      for (let item of this.question) {
        if (item.que_filed == 'camp_weight') {
          return item.value
        }
      }
    }
  },
  watch: {
    id(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.init()
        this.$refs.appRuler?.initRuler()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.data.value === '') {
        this.NowNum = +this.data.default_value
      } else {
        this.NowNum = +this.data.value
      }
    },
    bindClick() {
      this.showRuler = true
    },
    bindConfirm(value) {
      this.$emit('change', value)
      this.data.value = value + ''
    }
  }
}
</script>
<style lang="scss" scoped>
.question-ruler {
  margin-top: 19vh;
  .cur-weight {
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 16px;
  }

  .target-weight {
    margin: 0 auto;
    margin-bottom: 10px;
    width: 230px;
    height: 106px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2efb0ce00c70f82bcdf7a0d090a64567.png');
    background-size: contain;
  }

  .text {
    color: #6236ff;
    height: 40px;
    text-align: center;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .number {
    position: relative;
    font-size: 42px;
    font-family: DIN;
    font-weight: bold;
    line-height: 37px;
    letter-spacing: 1px;
    margin-right: 10px;
  }

  .unit {
    white-space: nowrap;
    position: absolute;
    left: 101%;
    bottom: 0%;
    transform: translate(0%, 0%);
    font-size: 14px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    line-height: 16px;
  }
}
.target-ruler {
  margin-top: 15vh;
}
</style>
